import { render, staticRenderFns } from "./tabEmployerProfile.vue?vue&type=template&id=794f6617&scoped=true&"
import script from "./tabEmployerProfile.vue?vue&type=script&lang=js&"
export * from "./tabEmployerProfile.vue?vue&type=script&lang=js&"
import style0 from "./tabEmployerProfile.vue?vue&type=style&index=0&id=794f6617&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794f6617",
  null
  
)

export default component.exports